export default __webpack_public_path__ + "static/media/banner_dog.c588f337.png";